import React from 'react';

import { useSelector } from 'react-redux';

import Link from 'next/link';

import clsx from 'clsx';

import { removeBasePath } from '@bonnet/next/base-path';

// modules
import { Glyphicon } from 'reaxl';
import { sendClick } from 'reaxl-analytics';

import SearchLinkModule from '@/modules/SearchLinkModule';

/*
 * SearchLink will generate a link to an SRP based on the current listing or request
 * only on VDP requests that are from external links (emails, non-findcar applications, etc)
 */
export function SearchLink({
    className,
}) {

    const { link: searchLinkHref, label: searchLinkLabel } = useSelector(SearchLinkModule.duck.selectors.getDuckState);

    // return empty element to preserve layout
    if (!searchLinkHref) {
        return null;
    }

    const handleSearchLinkClick = (event) => {
        sendClick('searchLinkClick', event);
    };

    return (
        <Link
            data-cmp="searchLink"
            href={removeBasePath(searchLinkHref)}
            className={clsx('padding-left-0 text-nowrap margin-vertical-2 btn btn-link text-bold', className)}
            onClick={handleSearchLinkClick}
        >
            <Glyphicon
                glyph="menu-left"
                className="margin-right-1"
                aria-hidden="true"
            />
            {searchLinkLabel}
        </Link>
    );
}

export default React.memo(SearchLink);
